import { Grid } from '@material-ui/core';
import React, { FunctionComponent, useState } from 'react';
import SummaryLabelTitle from '../../../summaryLabel/SummaryLabelTitle';
import PriceValue from '../priceValue/PriceValue';
import useSelectedCurrencyDiscountPrice from '../../../../../../../../gqlCommon/hooks/currency/useSelectedCurrencyDiscountPrice';
import summaryLabelStyles from '../../../summaryLabel/SummaryLabelStyles';
import { GetCustomizeCar_customizeCar_prices_carPrice_offers_discounts as IDiscount } from '../../../../../../../graphql/queries/__generated__/GetCustomizeCar';
import useCarDiscountsPrices from '../../../../../../../hooks/prices/useCarDiscountsPrices';
import { PriceDisplayType } from '../../../../../../../../../../common/enum/PriceDisplayType';

export interface IDiscountProps {
  loading?: boolean;
  currency: string;
  label: string;
  boldPrice?: boolean;
  boldLabel?: boolean;
  discount: IDiscount;
}

const SummaryDiscount: FunctionComponent<IDiscountProps> = ({
  loading,
  currency,
  discount,
  label,
  boldPrice,
  boldLabel,
}) => {
  const styles = summaryLabelStyles();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const discountedPrice = useCarDiscountsPrices(discount?.value);
  const { selectedCurrencyDiscountPrice } = useSelectedCurrencyDiscountPrice(discountedPrice);

  return (
    <Grid
      container={true}
      justifyContent={'space-between'}
      spacing={3}
      className={styles.lineContainer}
      data-test="summary:discount:container"
    >
      <SummaryLabelTitle
        label={label}
        boldLabel={boldLabel}
        colSm={8}
        colXs={6}
        isTooltipOpen={isTooltipOpen}
        toggleTooltip={setIsTooltipOpen}
        tooltipText={discount?.disclaimer}
      />
      <PriceValue
        loading={loading}
        price={selectedCurrencyDiscountPrice}
        priceType={PriceDisplayType.PRIMARY}
        currency={currency}
        boldPrice={boldPrice}
        showSign={true}
        testId={'discounts'}
      />
    </Grid>
  );
};

export default SummaryDiscount;
